import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AGENCY } from "../data/content";

export default function Impressum() {
  return (
    <main className="min-h-screen bg-[#101318] py-24 px-6 md:px-12" data-testid="impressum-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-bold text-[#2E5BFF] hover:text-white transition-colors mb-10" data-testid="impressum-back-link">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Impressum</h1>
        <div className="mt-10 space-y-8 text-[#9AA3AF] leading-relaxed">
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">Angaben gemäß § 5 TMG</h2>
            <p>
              {AGENCY.name}<br />
              Inhaber: {AGENCY.founder}<br />
              [Straße und Hausnummer werden ergänzt]<br />
              [PLZ und Ort werden ergänzt], {AGENCY.region}
            </p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">Kontakt</h2>
            <p>
              E-Mail: {AGENCY.email}<br />
              [Telefonnummer wird ergänzt]
            </p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">Umsatzsteuer</h2>
            <p>[Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG wird ergänzt]</p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>{AGENCY.founder}, Anschrift wie oben.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-semibold text-[#F2F4F7] mb-3">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
